var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.activityLogEntry.target && _vm.activityLogEntry.target.length && _vm.activityLogEntry.target[0].refType ? _c('timeline-card', {
    attrs: {
      "title": _vm.$t('timeLine.ActivityTimeLineItemCreateRef.title', {
        name: _vm.name,
        date: _vm.date,
        type: _vm.$t("BackendResourceEnum.".concat(_vm.activityLogEntry.target[0].refType))
      })
    },
    scopedSlots: _vm._u([{
      key: "menu",
      fn: function fn() {
        return [_c('v-btn', {
          staticClass: "mt-n1",
          attrs: {
            "x-small": "",
            "outlined": "",
            "color": "info"
          },
          on: {
            "click": _vm.openSideCard
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemTicket.detail")) + " ")]), _c('activity-time-line-item-delete', {
          attrs: {
            "partnerId": _vm.activityLogEntry.partnerId,
            "activityId": _vm.activityLogEntry.id
          }
        })];
      },
      proxy: true
    }], null, false, 1578871827)
  }, [_vm.activityLogEntry.target && _vm.activityLogEntry.target.length ? _c('refs-selected', {
    attrs: {
      "partnerId": _vm.activityLogEntry.partnerId,
      "value": [_vm.activityLogEntry.target[0]],
      "confirmable": false,
      "outlined": false,
      "removable": false,
      "draggable": false
    }
  }) : _vm._e(), _vm.value && _vm.value.element && _vm.value.refType === _vm.ResourceEnum.REPAIR_ESTIMATE ? _c('repair-estimate-side-card', {
    attrs: {
      "value": _vm.value.element
    },
    on: {
      "close": function close($event) {
        _vm.value = null;
      }
    }
  }) : _vm._e(), _vm.value && _vm.value.element && _vm.value.refType === _vm.ResourceEnum.CLEARANCE ? _c('clearance-side-card', {
    attrs: {
      "value": _vm.value.element
    },
    on: {
      "close": function close($event) {
        _vm.value = null;
      }
    }
  }) : _vm._e(), _vm.value && _vm.value.element && _vm.value.refType === _vm.ResourceEnum.CLEARANCE_APPROVAL ? _c('clearance-approval-side-card', {
    attrs: {
      "value": _vm.value.element
    },
    on: {
      "close": function close($event) {
        _vm.value = null;
      }
    }
  }) : _vm._e()], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }